import { createContext } from 'react';
/**
 * The context that is used to provide the theme data to the theme consumer.
 */
export const themeContext = createContext(null);
